import actionTypes from './actionTypes';

export function loadPollingStations(pollingStations) {
  return {
    type: actionTypes.LOAD_POLLING_STATIONS,
    payload: pollingStations,
  };
}

export function loadWhitelist(whitelist) {
  return {
    type: actionTypes.LOAD_WHITELIST,
    payload: whitelist,
  };
}

export function loadResults(results) {
  return {
    type: actionTypes.LOAD_RESULTS,
    payload: results,
  };
}

export function loadDetached(detached) {
  return {
    type: actionTypes.LOAD_DETACHED,
    payload: detached,
  };
}

export function loadPollBuilder(questions) {
  return {
    type: actionTypes.LOAD_POLL_BUILDER,
    payload: questions,
  };
}

export function loadPollChoices(choices) {
  return {
    type: actionTypes.LOAD_POLL_CHOICES,
    payload: choices,
  };
}

export function changePollChoices(data) {
  return {
    type: actionTypes.CHANGE_POLL_CHOICES,
    payload: data,
  };
}

export function loadSocialData() {
  return {
    type: actionTypes.LOAD_SOCIAL_DATA,
  };
}

export function changeSocialData(data) {
  return {
    type: actionTypes.CHANGE_SOCIAL_DATA,
    payload: data,
  };
}

export function loadPollResults(results) {
  return {
    type: actionTypes.LOAD_POLL_RESULTS,
    payload: results,
  };
}

export function loadUserData(data) {
  return {
    type: actionTypes.LOAD_USER_DATA,
    payload: data,
  };
}

export function changeTokenStatus(status) {
  return {
    type: actionTypes.CHANGE_TOKEN_STATUS,
    payload: status,
  };
}

export function loadWebpoll(webpoll) {
  return {
    type: actionTypes.LOAD_WEBPOLL,
    payload: webpoll,
  };
}

export function loadWebpollAnswers(answers) {
  return {
    type: actionTypes.LOAD_WEBPOLL_ANSWERS,
    payload: answers,
  };
}

export function setWebpollAnswer({ questionId, answerId }) {
  return {
    type: actionTypes.SET_WEBPOLL_ANSWER,
    payload: { questionId, answerId },
  };
}

export function setWebpollPage(pageIndex) {
  return {
    type: actionTypes.SET_WEBPOLL_PAGE,
    payload: pageIndex,
  };
}

export function setWebpollToken(token) {
  return {
    type: actionTypes.SET_WEBPOLL_TOKEN,
    payload: token,
  };
}

export function loadWebpollTokenStatusStart() {
  return {
    type: actionTypes.LOAD_WEBPOLL_TOKEN_STATUS + actionTypes.START,
  };
}

export function loadWebpollTokenStatusSuccess(status) {
  return {
    type: actionTypes.LOAD_WEBPOLL_TOKEN_STATUS + actionTypes.SUCCESS,
    payload: status,
  };
}

export function loadWebpollTokenStatusFailure() {
  return {
    type: actionTypes.LOAD_WEBPOLL_TOKEN_STATUS + actionTypes.FAIL,
  };
}

export function setWebpollCompleted(isCompleted) {
  return {
    type: actionTypes.SET_WEBPOLL_COMPLETED,
    payload: isCompleted,
  };
}
